module.exports = __webpack_public_path__ + "624c1255/img/22000000-0.3e8ca691.png";